// src/pages/RendezVous.jsx
const RendezVous = () => {
  return (
    <div>
      <h1>📅 Prendre un rendez-vous</h1>
      <p>Page en construction... Vous pourrez bientôt prendre rendez-vous en ligne.</p>
    </div>
  );
};
export default RendezVous;